import { observer } from 'mobx-react-lite';
import { Link } from 'react-router-dom';
import {
  Box,
  Card,
  CardContent,
  Typography,
  Button,
  Divider,
} from '@mui/material';
import { Edit as EditIcon } from '@mui/icons-material';
import { useAuthStore } from '../../stores/root_store';

export const SettingsOverview = observer(() => {
  const authStore = useAuthStore();
  const user = authStore.user;

  if (!user) {
    return null;
  }

  const memberSince = new Date(user.date_created).toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });

  return (
    <Card>
      <CardContent>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
          <Typography variant="h6">Account Overview</Typography>
          <Button
            component={Link}
            to="/settings/edit"
            variant="outlined"
            size="small"
            startIcon={<EditIcon />}
          >
            Edit Profile
          </Button>
        </Box>

        <Divider sx={{ mb: 2 }} />

        <Box sx={{ display: 'grid', gap: 2 }}>
          <Box>
            <Typography variant="body2" color="text.secondary">
              Name
            </Typography>
            <Typography variant="body1">
              {user.first_name || user.last_name
                ? `${user.first_name || ''} ${user.last_name || ''}`.trim()
                : user.name || 'Not set'}
            </Typography>
          </Box>

          <Box>
            <Typography variant="body2" color="text.secondary">
              Email
            </Typography>
            <Typography variant="body1">{user.primary_email}</Typography>
          </Box>

          <Box>
            <Typography variant="body2" color="text.secondary">
              Member Since
            </Typography>
            <Typography variant="body1">{memberSince}</Typography>
          </Box>

          {(!user.is_beta || user.tasks_remaining > 0) && (
            <Box>
              <Typography variant="body2" color="text.secondary">
                Tasks Remaining
              </Typography>
              <Typography variant="body1">{user.tasks_remaining}</Typography>
            </Box>
          )}
        </Box>
      </CardContent>
    </Card>
  );
});
